<template>
  <div style="margin: 4px 16px 16px;">
    <div class="content-input" style="margin-bottom: 8px;">
      <div class="content-input-left">
        <div class="dialog-input-item">
          <DatePickerRange title="消费时间" @date="getTime($event)" @check="getCheck($event)" :isChecked="isChecked"/>
        </div>
        <div class="dialog-input-item">
          <label>消费门店</label>
          <el-select v-model="shopId" placeholder="Select" class="select-item">
            <el-option v-for="item in shopIdArray" :key="item.id" :label="item.name" :value="item.id">
            </el-option>
          </el-select>
        </div>
        <div class="dialog-input-item">
          <label>预约类型</label>
          <el-select v-model="type" placeholder="Select" class="select-item">
            <el-option v-for="item in typeArray" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
          <label style="margin-left: 16px;">零食状态</label>
          <el-select v-model="snackState" placeholder="Select" class="select-item">
            <el-option v-for="item in snackStateArray" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="dialog-input-item">
          <!--          <label>记录搜索</label>-->
          <SearchComponents width="7.2em" :searchTypeList="searchTypeList" :searchType="searchType"  :searchValue="searchValue" @searchType="getSearchType($event)" @searchValue="getSearchValue($event)" />
          <!--            <el-checkbox v-model="limitState" style="margin-left: 8px;">有限制</el-checkbox>-->
        </div>
      </div>

      <div class="content-input-right">
        <div class="dialog-input-btn">
          <ElButtons type="primary" icon="search" v-loading="searchLoading" :disable="searchLoading" @click="getPage(true)"> 查询 </ElButtons>
          <!--          <el-button type="success" @click="add">添加</el-button>-->
        </div>
        <div class="dialog-input-btn">
          <ElButtons type="success" icon="Plus"  @click="checkDetail(-1)"> 添加 </ElButtons>
<!--          <el-button type="success" @click="add">添加</el-button>-->
        </div>
      </div>
    </div>
    <el-table
        ref="multipleTableRef"
        :data="pageDataList"
        style="width: 100%; "
        v-loading="listLoading"
        @cell-click="toggleSelection"
        size="default"
        border
    >
      <!--            <el-table-column property="id" label="ID" v-if="checkColList.indexOf('ID') > -1"/>-->
      <el-table-column property="createTime" label="消费时间" width="104"/>
      <el-table-column property="shopName" label="消费门店" width="90"/>
      <el-table-column property="numberNo" label="消费单号" width="90"/>
      <el-table-column property="" label="消费项目">
        <template #default="scope">
<!--          <p style="font-weight: bold" v-if="scope.row.contentObj.title">{{scope.row.contentObj.title}}</p>-->
<!--          <p>{{scope.row.contentObj.content}}</p>-->
          <p v-for="(item, index) in scope.row.contentArr" :key="index" :style="{fontWeight: index==0?'bold':''}">{{item}}<span v-if="index>0">；</span></p>
        </template>
      </el-table-column>
      <el-table-column property="paymentDetailContent" label="支付记录"/>
      <el-table-column property="" label="零食状态" width="90">
        <template #default="scope">
          {{scope.row.snackState == 1?'已赠送': scope.row.snackState == 2?'未赠送':''}}
        </template>
      </el-table-column>
      <el-table-column property="" label="类型" width="70">
        <template #default="scope">
          {{scope.row.type == 1?'预约单': scope.row.type == 2?'普通单':''}}
        </template>
      </el-table-column>
      <el-table-column property="adminName" label="添加人" width="100"/>
      <el-table-column property="consumeRemark" label="消费备注" width="100" class-name="cursor">
        <template #default="scope">
          <p v-if="scope.row.consumeRemark">{{scope.row.consumeRemark}}</p>
          <p v-else style="color: #409eff">编辑</p>
        </template>
      </el-table-column>
      <el-table-column property="" label="操作" width="60">
        <template #default="scope">
          <el-button type="text" @click="checkDetail(scope.$index, scope.row)">查看</el-button>
        </template>
      </el-table-column>
    </el-table>
    <!--分页-->
    <el-pagination background @current-change="handleCurrentChange" :current-page="currentPage" :page-size="pageSize" layout="total, prev, pager, next, jumper" :total="totalRow" style="text-align:right;margin-top: 24px;">
    </el-pagination>
  </div>
</template>

<script>
import { getFormData } from '@/api/api';
import {getAllShopList, pageUserConsumeList, getRecordShops, getUserInfo} from '@/api/url';
import Dialog from '@/assets/js/dialog'
import Drawer from '@/assets/js/drawer'
// import AddUserRemarkDialog from './AddUserRemarkDialog';
import DatePickerRange from "@/components/DatePickerRange_30";
import SearchComponents from "@/components/SearchComponents";
// import PayDetailDialog from "@/views/user/components/payment/PayDetailDialog";
// import ProjectDetailDialog from "@/views/user/components/project/ProjectDetailDialog";
// import EditPaymentDialog from "@/views/user/components/payment/EditPaymentDialog";
// import EditProjectDialog from "@/views/user/components/project/EditProjectDialog";
import ConsumeDetailDialog from "@/views/user/components/ConsumeDetailDialog";
// import UserRemarkDialog from "@/components/Remark/UserRemarkDialog";
import ComsumeRemarkDialog from "@/views/user/components/ComsumeRemarkDialog";
export default {
  props: {
    value: Object
  },
  components: {DatePickerRange, SearchComponents},
  data() {
    return {
      userForm: this.value.userForm,
      pageDataList: [],
      id: this.value.id,
      totalRow: 0,
      pageSize: 20,
      currentPage: 1,
      listLoading: false,
      searchLoading: false,

      typeArray: [
        {label: '不限', value: -1},
        {label: '预约单', value: 1},
        {label: '普通单', value: 2},
      ],
      type: -1,

      snackStateArray: [
        {label: '不限', value: -1},
        {label: '已赠送', value: 1},
        {label: '未赠送', value: 2},
      ],
      snackState: -1,

      //时间
      startTime: '',
      endTime: '',
      isChecked: true,

      //搜索
      searchTypeList: [
        {label : '消费单号', value : 1},
        {label : '添加人', value : 2},
      ],
      searchType: 1,
      searchValue: '',

      shopIdArray: [],
      shopIdArr:[],
      shopId: 0,

      // visibleShopList: JSON.parse(sessionStorage.getItem('visibleShopList')),
    }
  },
  methods: {

    getTime(val) {
      this.startTime = val[0];
      this.endTime = val[1];
      // console.log(val)
    },
    getCheck(val) {
      this.isChecked = val
    },

    getSearchType(e) {
      this.searchType = e;
    },
    getSearchValue(e) {
      this.searchValue = e;
    },

    //分页
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getPage();
    },

    getPage(reset) {
      if(isNaN(this.currentPage)) {
        this.$message({
          showClose: true,
          duration: 1000,
          message: '请提交正确的页码',
          type: 'warning'
        })
      } else {
        if(reset) {
          this.currentPage = 1;
        }
        this.searchLoading = true;
        this.listLoading = true;
        this.sendPageReq(this.getPageParam(this.currentPage));
      }
    },

    //页面参数
    getPageParam(page) {
      let param = {};
      param['pageNum'] = page;
      param['userId'] = this.id;
      param['type'] = this.type;
      param['startTime'] = this.startTime;
      param['endTime'] = this.endTime;
      param['shopId'] = this.shopId;
      param['snackState'] = this.snackState;
      param['searchType'] = this.searchType;
      param['searchValue'] = this.searchValue;
      this.pageParam = param;
      return param;
    },
    // 发送页面列表请求
    sendPageReq(param) {
      getFormData(pageUserConsumeList, param).then((data) => {
        let {msg, code } = data;
        if(code == 200) {
          let result = data['data'];
          this.pageDataList = result['records'];
          this.totalRow = result['total'];
          this.pageSize = result['size'];

          this.pageDataList.map(item => {
            let arr = []
            if(item.projectAllContent) {
              arr = item.projectAllContent.split('，')
            }
            item.contentArr = arr
          })

        }else{
          this.$message({
            showClose: true,
            duration: 1000,
            message: msg,
            type: 'warning'
          })
        }
        this.searchLoading = false;
        this.listLoading = false;
      })
          .catch((response) => {
            this.searchLoading = false;
            this.listLoading = false;
          })
    },

    // add() {
    //   let proDetailForm = {};
    //   Drawer.open({
    //     title: '添加消费项目',
    //     component: EditProjectDialog,
    //     data: {
    //       userForm: this.userForm,
    //       // userId: this.userForm.id,
    //       idx: -1,
    //       proDetailForm: proDetailForm,
    //       checkList: this.userForm.petIdList,
    //       width: 1000
    //     },
    //     confirm: (result) => {
    //       this.getPage();
    //       sessionStorage.setItem('recordState', JSON.stringify(true))
    //     }
    //   })
    // },

    checkDetail(idx, row) {
      let consumeForm = {}
      let consumeId = 0
      if(idx > -1) {
        consumeForm = Object.assign({}, row);
        consumeId = consumeForm.id
      }
      Dialog.open({
        title: '消费单',
        component: ConsumeDetailDialog,
        data: {
          userForm: this.userForm,
          consumeId: consumeId,
          idx: idx,
          width: '800px'
        },
        confirm: (result) => {
          this.getPage();
          this.getUserInfo()
          sessionStorage.setItem('recordState', JSON.stringify(true))
        }
      })
    },

    getUserInfo() {
      getFormData(getUserInfo, {id: this.userForm.id}).then(data => {
        this.userForm = data.data
      })
    },

    getShopList() {
      let param = {}
      param['userId'] = this.userForm.id
      param['type'] = 1
      getFormData(getRecordShops, param).then(data=> {
        data.data.map((item) => {
          this.shopIdArr.push(item)
        })
        this.shopIdArray = this.shopIdArray.concat(this.shopIdArr)
      })
    },

    toggleSelection(row, column, cell, event) {

      //更新用户日志
      if (column.label == '消费备注') {
        Dialog.open({
          title: '单号【'+ row.numberNo +'】的消费备注',
          component: ComsumeRemarkDialog,
          data: {
            id: row.id,
            remark: row.consumeRemark,
            width: '500px'
          },
          confirm: (result) => {
            row.consumeRemark = result.consumeRemark
            // this.getPage()
          }
        })
      }
    }

  },
  mounted() {
    this.getShopList()
    this.getPage();
    this.getUserInfo()
  }
}
</script>

<style>

</style>
